import { FC } from 'react'
import { composeClasses } from '@/utils/compose-classes'

export interface StepProcessProps {
  title: string
  stepText: string
  className?: string
}
export const StepProcess: FC<StepProcessProps> = ({
  title,
  stepText,
  className
}) => {
  return (
    <div className={composeClasses(className, 'flex gap-6')}>
      <p className="text-body-bold-m">{title}</p>
      <p className="text-body-m text-secondary">{stepText}</p>
    </div>
  )
}
